import { __ } from '@wordpress/i18n'

export const states = [
  { value: 'BW', label: __('Baden-Württemberg', 'dhsv_theme') },
  { value: 'BY', label: __('Bayern', 'dhsv_theme') },
  { value: 'BE', label: __('Berlin', 'dhsv_theme') },
  { value: 'BB', label: __('Brandenburg', 'dhsv_theme') },
  { value: 'HB', label: __('Bremen', 'dhsv_theme') },
  { value: 'HH', label: __('Hamburg', 'dhsv_theme') },
  { value: 'HE', label: __('Hessen', 'dhsv_theme') },
  { value: 'MV', label: __('Mecklenburg-Vorpommern', 'dhsv_theme') },
  { value: 'NI', label: __('Niedersachsen', 'dhsv_theme') },
  { value: 'NW', label: __('Nordrhein-Westfalen', 'dhsv_theme') },
  { value: 'RP', label: __('Rheinland-Pfalz', 'dhsv_theme') },
  { value: 'SL', label: __('Saarland', 'dhsv_theme') },
  { value: 'SN', label: __('Sachsen', 'dhsv_theme') },
  { value: 'ST', label: __('Sachsen-Anhalt', 'dhsv_theme') },
  { value: 'SH', label: __('Schleswig-Holstein', 'dhsv_theme') },
  { value: 'TH', label: __('Thüringen', 'dhsv_theme') },
  { value: '1', label: __('Burgenland', 'dhsv_theme') },
  { value: '2', label: __('Kärnten', 'dhsv_theme') },
  { value: '3', label: __('Niederösterreich', 'dhsv_theme') },
  { value: '4', label: __('Oberösterreich', 'dhsv_theme') },
  { value: '5', label: __('Salzburg', 'dhsv_theme') },
  { value: '6', label: __('Steiermark', 'dhsv_theme') },
  { value: '7', label: __('Tirol', 'dhsv_theme') },
  { value: '8', label: __('Vorarlberg', 'dhsv_theme') },
  { value: '9', label: __('Wien', 'dhsv_theme') },
  { value: 'Anderer', label: __('Nicht zutreffend', 'dhsv_theme') },
]

export const statesCH = [
  { value: 'AA', label: __('Aargau', 'dhsv_theme') },
  { value: 'AR', label: __('Appenzell Ausserrhoden', 'dhsv_theme') },
  { value: 'AI', label: __('Appenzell Innerrhoden', 'dhsv_theme') },
  { value: 'BL', label: __('Basel-Landschaft', 'dhsv_theme') },
  { value: 'BS', label: __('Basel-Stadt', 'dhsv_theme') },
  { value: 'BE', label: __('Bern', 'dhsv_theme') },
  { value: 'FR', label: __('Fribourg (Freiburg)', 'dhsv_theme') },
  { value: 'GL', label: __('Glarus', 'dhsv_theme') },
  { value: 'GR', label: __('Graubünden (Grischun)', 'dhsv_theme') },
  { value: 'GE', label: __('Gèneve (Genf)', 'dhsv_theme') },
  { value: 'JU', label: __('Jura', 'dhsv_theme') },
  { value: 'LU', label: __('Luzern', 'dhsv_theme') },
  { value: 'NE', label: __('Neuchâtel', 'dhsv_theme') },
  { value: 'NW', label: __('Nidwalden', 'dhsv_theme') },
  { value: 'OW', label: __('Obwalden', 'dhsv_theme') },
  { value: 'SH', label: __('Schaffhausen', 'dhsv_theme') },
  { value: 'SZ', label: __('Schwyz', 'dhsv_theme') },
  { value: 'SO', label: __('Solothurn', 'dhsv_theme') },
  { value: 'SG', label: __('St. Gallen', 'dhsv_theme') },
  { value: 'TG', label: __('Thurgau', 'dhsv_theme') },
  { value: 'TI', label: __('Ticino (Tessin)', 'dhsv_theme') },
  { value: 'UR', label: __('Uri', 'dhsv_theme') },
  { value: 'VS', label: __('Valais (Wallis)', 'dhsv_theme') },
  { value: 'VD', label: __('Vaudt (Waadt)', 'dhsv_theme') },
  { value: 'ZG', label: __('Zug', 'dhsv_theme') },
  { value: 'ZH', label: __('Zürich', 'dhsv_theme') },
  { value: 'Anderer', label: __('Nicht zutreffend', 'dhsv_theme') },
]
